import React from 'react'
import { Button, Icon } from '@insight/toolkit-react'
import { t, isDesktop } from '@insight/toolkit-utils'
import { FilterTooltip } from '../../../lib/FilterTooltip'

export const AIDeviceTooltip = ({ locale = 'en_US' }) => {
    const discoverUrl = `/${locale}/shop/category/notebooks/ai-powered-laptops.html`
    const desktopView = isDesktop()
    // Only show the Discover AI link for en_US and desktop view
    const showDiscoverButton = desktopView && locale === 'en_US'
    return (
        <FilterTooltip
            header={
                <>
                    <strong>{t('AI Device Type')}</strong>
                    {showDiscoverButton && (
                        <Button
                            color="link"
                            icon="open"
                            iconPosition="right"
                            href={discoverUrl}
                            target="_blank"
                        >
                            {t('Discover our AI Laptops')}
                        </Button>
                    )}
                </>
            }
            body={
                <div>
                    <p className="c-filter-tooltip__body__headings">{t('AI-Ready')}</p>
                    <p>
                        {t(
                            'A hardware-enabled AI PC with a Neural Processing Unit (NPU) delivering less than 40 Tera Operations Per Second (TOPS); supports foundational on-device AI capabilities.'
                        )}
                    </p>
                    <p className="c-filter-tooltip__body__headings">{t('Copilot+ PC')}</p>
                    <p>
                        {t(
                            "A next-generation AI PC with a Neural Processing Unit (NPU) delivering 40–60 Tera Operations Per Second (TOPS) and meeting Microsoft's requirements; enables advanced, system-wide AI experiences."
                        )}
                    </p>
                    <p className="c-filter-tooltip__body__headings">{t('AI-Capable')}</p>
                    <p>
                        {t(
                            'A traditional PC without a dedicated Neural Processing Unit (NPU); relies on CPU/GPU for AI tasks and does not accelerate on-device AI workloads.'
                        )}
                    </p>
                </div>
            }
            position="right"
            trigger={
                <span
                    className="c-search-filter__group__tooltip-icon"
                    aria-label={t('AI Device Type')}
                >
                    <Icon icon="information-circled" size="small" />
                </span>
            }
            hoverable={true}
            showDelay={200}
            hideDelay={200}
        />
    )
}
